export default __webpack_public_path__ + "static/image-9-mob-079c41f27ad7acf5bef7995455925b8d.jpg";